





























import Vue from 'vue'
import {Component} from "vue-property-decorator";
import ResponsiveContainer from "@/components/Shared/ResponsiveContainer.vue";
import {RouteNames} from "@/router/types";

@Component({
  components: {ResponsiveContainer},
  enums: {
    RouteNames
  }
})
export default class UserSettingsPage extends Vue {

}
